import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { CircuitPortIdentifierData } from "../6-osc-management/osc-management-step.model";

/**
 * Representa o modelo do step Amplifiers do DwdmCircuitWizard.
 */
export class AmplifiersStepModel extends NmsWizardStepModel {
    circuitId?: number;
    configuredAmplifiers: Array<Amplifier>
    getClassName: () =>  "AmplifiersStepModel"
}

/**
 * Modelo de dados que representa um amplificador.
 * Utilizado na tabela de amplificadores e no modelo do step.
 */
export interface Amplifier {
    portIdentifier: CircuitPortIdentifierData;
    identifier: string;
    hostname: string;
    links: Array<DwdmAmplifierLink>;
    portName: string;
    portDescription: string;
    profile: DwdmCircuitAmplifierProfileData;
    profileLabel: string;
    mode: DwdmCircuitAmplifierModeTypeData;
    modeLabel: string;
    value: string;
    limit: string;
    losAction: string;
    losThreshold: string;
}

/**
 * Modelo de dados utilizado na comunicação entre a tabela de amplificadores
 * e a modal de configuração de um amplificador.
 */
export interface AmplifierConfigInfo {
    profile: DwdmCircuitAmplifierProfileData;
    mode: DwdmCircuitAmplifierModeTypeData;
    value: number;
    limit: number;
    losAction: boolean;
    losThreshold: number;
    links: Array<DwdmAmplifierLink>;
}

/** Interface utilizada na requisição de amplificadores */
export interface DwdmAmplifierRequestData {
    deviceAEnd: number;
    deviceZEnd: number;
    linkIds: Array<number>;
}

/** Interface utilizada na resposta da requisição de amplificadores para popular a tabela*/
export interface DwdmAmplifierData {
    links: Array<DwdmAmplifierLink>;
    deviceResourceId: number;
    deviceName: string;
    chassisNo: string;
    slotNo: string;
    portNo: number
    portModel: string;
    portName: string;
    portDescription: string;
    profile: DwdmCircuitAmplifierProfileData;
}

/** Interface que representa o valor default dos campos de operação do amplificador utilizado na modal*/
export interface DwdmCircuitAmplifierSettingsData {
    defaultValue: number;
    minValue: number;
    maxValue: number;
    defaultLimit: number;
    minLimit: number;
    maxLimit: number;
    defaultLosThreshold: number;
    minLosThreshold: number;
    maxLosThreshold: number;
    defaultLosAction: boolean;
}

/**
 * Interface que representa o valor corrente dos campos de amplificadores na modal.
 */
export interface AmplifierCurrentConfig extends DwdmCircuitAmplifierSettingsData {
    value: number;
    limit: number;
    losThreshold: number;
    losAction: boolean;
}

/** Interface que representa os valores de operação do amplificador */
export interface DwdmAmplifierLink {
    linkId: number;
    linkName: string;
}

/** Enum que representa os tipos de profiles na tabela */
export enum DwdmCircuitAmplifierProfileData {
    PRE_AMP = "PRE_AMP",
    BOOSTER = "BOOSTER"
}

/** Enum que representa o modo de operação do amplificador na tabela */
export enum DwdmCircuitAmplifierModeTypeData {
    GAIN = "GAIN",
    POWER = "POWER"
}

/** Enum que representa o valor textual da coluna LOS Action na tabela */
export enum LosAction {
    ENABLED = "Enabled",
    DISABLED = "Disabled"
}

/** Define uma interface para as configurações do texto de GAIN e POWER do amplificador */
interface ConfigLabelAmplifierText  {
    valueText: string,
    limitText: string
}

/** Define o tipo que mapeia o texto de GAIN e POWER do amplificador exibidos na modal*/
export type AmplifierLabelMap = {
    [key in DwdmCircuitAmplifierModeTypeData]: ConfigLabelAmplifierText
}

/** Objeto que mapeia as combinações para os textos do amplicador GAIN e POWER exibidos na modal */
export const AMPLIFIER_TEXT: AmplifierLabelMap = {
    [DwdmCircuitAmplifierModeTypeData.GAIN]: {
        valueText: "Gain Value",
        limitText: "Power Limit"
    },
    [DwdmCircuitAmplifierModeTypeData.POWER]: {
        valueText: "Power Value",
        limitText: "Gain Limit"
    }
};

/** Mapa para labels de Mode */
export const MODE_LABEL_MAP = {
    [DwdmCircuitAmplifierModeTypeData.GAIN]: "Gain",
    [DwdmCircuitAmplifierModeTypeData.POWER]: "Power",
};

/** Mapa para labels de Profile */
export const PROFILE_LABEL_MAP = {
    [DwdmCircuitAmplifierProfileData.PRE_AMP]: "Pre-Amp",
    [DwdmCircuitAmplifierProfileData.BOOSTER]: "Booster",
};

/**
 * Modelo de validação utilizado no passo amplificadores.
 */
export interface AmplifiersValidatorData {
    amplifiers: Array<AmplifierValidatorData>;
}

/**
 * Model com dados necessários para validação de um amplificador.
 */
export interface AmplifierValidatorData {
    portIdentifier: CircuitPortIdentifierData;
    limit: string;
    losAction: string;
    losThreshold: string;
    mode: string;
    profile: string;
    value: string;
}

